import * as React from 'react';
import * as OBC from "@thatopen/components";
import * as OBCF from "@thatopen/components-front";
import * as THREE from "three";
import Uploader from '../Uploader/Uploader';
import { useApi } from '../Api/useApi';
import { Box, Button, Stack, SxProps, Theme, Tooltip } from '@mui/material';
import loadIfcLocalFile from './Files/loadIfcLocalFile';
import { InitializeViewer } from './InitializeViewer';
import loadFragmentsFromUri from './Files/loadFragmentsFromUri';
import { Backdrop, CircularProgress } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { ViewCube } from './ViewCube';
import { AddClipper } from './AddClipper';
import PropertiesDataGrid from './Properties/PropertiesDataGrid';
import { AddMeasurment } from './AddMeasurment';
import ModelTree from './Tree/ModelTree';
import { AccountTree, Camera, OpenInBrowser, Refresh, SquareFoot, TableChart, WaterfallChart } from '@mui/icons-material';

import { ModelInfo } from './Models/ModelInfo';
import { Isolate } from './PostProcessing/Isolate';
import { ResetPostProcessing } from './PostProcessing/ResetPostProcessing';
import { Hide } from './PostProcessing/Hide';
import { IfcUploaded } from './Files/IfcUploaded';
import { Select } from './PostProcessing/Select';
import DragableWindow from '../Shared/DraggableWindow';
import { FileParameter, GetModelSasUrisFromProjectIdResponse, ModelRycApiClient, ProjectsRycApiClient } from '../Api/ApiServer';
import { useProject } from '../Contexts/Hooks/useProject';
import { RycIsProjectModule } from '../Enums/RycIsProjectModule';
import { fullHeight } from '../Shared/getFullHeight';
import { handleBlobFileUpload } from '../Uploader/HandleBlobFileUpload';

interface BIMViewerProps {
    embeded?: boolean;
    containerWidth?: number;
    modelData?: GetModelSasUrisFromProjectIdResponse;

}

export default function BIMViewer(props: Readonly<BIMViewerProps>) {
    const [componentsState, setComponentsState] = React.useState<OBC.Components | null>(null);
    const [worldState, setWorldState] = React.useState<OBC.SimpleWorld | null>(null);
    const [highlighterState, setHighlighterState] = React.useState<OBCF.Highlighter | null>(null);
    const [loading, setLoading] = React.useState(false);
    const fileRef = React.useRef<HTMLInputElement>(null);
    const [modelIds, setModelIds] = React.useState<ModelInfo[]>([]);
    const [cameraPosition, setCameraPosition] = React.useState({ x: 0, y: 0, z: 0 });
    const [savedCameraPosition, setSavedCameraPosition] = React.useState({ x: 0, y: 0, z: 0 });
    const [showTree, setShowTree] = React.useState(false);
    const [resetHideIsolate, setResetHideIsolate] = React.useState(false);
    const [showGrid, setShowGrid] = React.useState(false);
    const { authorizedApi } = useApi(ModelRycApiClient);
    const projectApi = useApi(ProjectsRycApiClient);
    const loaded = React.useRef(false);
    const params = useParams();
    const navigate = useNavigate();
    const { setCurrentModule, setMenuButtons } = useProject();
    React.useEffect(() => {
        if (!props.embeded)
            setCurrentModule(RycIsProjectModule.Viewer);
    }, [setCurrentModule, props.embeded]);
    React.useEffect(() => {
        setMenuButtons(null);
    }, [setMenuButtons]);
    React.useEffect(() => {
        window.addEventListener('message', (event) => {

            const { type, data } = event.data;
            if (type === 'setViewPosition') {
                setCameraPosition({ x: data.x, y: data.y, z: data.z });
                if (worldState) {
                    worldState!.camera.controls!.setLookAt(data.x, data.y, data.z, 0, 0, -10);
                    if (data.selectedIds && data.selectedIds.length > 0 && componentsState && highlighterState) {
                        const fragments = componentsState!.get(OBC.FragmentsManager);
                        //other option is hover
                        if (!highlighterState.colors.has("customColor"))
                            highlighterState.add("customColor", new THREE.Color(0xFCC060));

                    }
                }
            }
        });
        return () => {
            window.removeEventListener('message', () => { });
        };
    }, [worldState, componentsState, highlighterState, modelIds]);
    const loadedModels = React.useRef(false);
    React.useEffect(() => {
        console.log('befddddloading', props.modelData);
        if (worldState && componentsState && loadedModels.current === false) {

            setLoading(true);
            setModelIds([]);
            console.log('befloading', props.modelData);
            if (props.modelData) {
                loadedModels.current = true;
                console.log('loading', props.modelData);
                if (!props.modelData?.modelUris || props.modelData?.modelUris?.length === 0) { setLoading(false); return; }
                // console.log('ModelsTTTT:', props.modelData?);
                props.modelData?.modelUris.forEach(async (model) => {
                    if (!model.modelUri || !model.modelId) return;
                    const frags = await loadFragmentsFromUri(model.modelUri, worldState, componentsState, model.modelId);
                    setModelIds(p => [...p, { fragmentId: frags.uuid, modelId: model.modelId! }]);
                });
                setLoading(false);
            }
            else if (params.id) {
                loadedModels.current = true;
                authorizedApi?.getModelsForProject(Number(params.id)).then(async (models) => {
                    if (!models.modelUris || models.modelUris?.length === 0) { setLoading(false); return; }
                    console.log('ModelsTTTT:', models);
                    models.modelUris.forEach(async (model) => {
                        if (!model.modelUri || !model.modelId) return;
                        const frags = await loadFragmentsFromUri(model.modelUri, worldState, componentsState, model.modelId);
                        setModelIds(p => [...p, { fragmentId: frags.uuid, modelId: model.modelId! }]);
                    });
                    setLoading(false);

                    // Promise.all(models.modelUris.map(async (model) => {
                    //     // if(model.modelId)
                    //     // return authorizedApi.getSasUrlForDownloadFragmets(model.modelId).then(async (url) => {
                    //     if (!model.modelUri || !model.modelId) return;
                    //     const frags = await loadFragmentsFromUri(model.modelUri, worldState, componentsState, model.modelId);
                    //     setModelIds(p => [...p, { fragmentId: frags.uuid, modelId: model.modelId! }]);
                    //     console.log('ModelIdsQQQ:', [...modelIds, { fragmentId: frags.uuid, modelId: model.modelId! }]);
                    // }
                    // })
                    // }
                    // )).finally(() => setLoading(false));
                });
            }
            else setLoading(false);
            // const modelIds = getModelIdsFromRoute();
            // if (modelIds.length === 0) return;
            // Promise.all(modelIds.map((id) =>
            //     authorizedApi.getSasUrlForDownloadFragmets(id).then(async (url) => {
            //         if (!url.modelUri) return;
            //         const frags = await loadFragmentsFromUri(url.modelUri, worldState, componentsState, id);
            //         setModelIds(p => [...p, { fragmentId: frags.uuid, modelId: id }]);
            //     })
            // )).finally(() => setLoading(false));
        }
    }, [worldState, componentsState, params, authorizedApi, props.embeded, props.modelData]);

    const [clipper, setClipper] = React.useState<OBC.Clipper | null>(null);
    const [lenghtMeasurer, setLenghtMeasurer] = React.useState<OBCF.LengthMeasurement | null>(null);
    const resetCamera = () => {
        worldState!.camera.controls!.setLookAt(
            savedCameraPosition.x,
            savedCameraPosition.y,
            savedCameraPosition.z,
            0, 0, -10
        );
    };
    React.useEffect(() => {
        if (!loaded.current) {
            loaded.current = true;
            const { components, world, highlighter } = InitializeViewer(setCameraPosition);
            console.log('world:', world);
            if (props.embeded !== true)
                ViewCube(world);
            const clipperResult = AddClipper(components, world);
            clipperResult.enabled = false;
            setClipper(clipperResult);
            const measurer = AddMeasurment(components, world);
            measurer.enabled = false;
            setLenghtMeasurer(measurer);

            setComponentsState(components);
            console.log('World:', world);
            setWorldState(world);
            setHighlighterState(highlighter);
        }
    }, []);
    const storeAndResetCamera = () => {
        setSavedCameraPosition(cameraPosition);
        // setSavedCameraTarget(cameraTarget);
        worldState!.camera.controls!.setLookAt(12, 6, 8, 0, 0, -10);
    };


    const changeClipperEnabled = () => {
        if (clipper) {
            if (clipper.enabled) {
                clipper.deleteAll();
            }
            else if (lenghtMeasurer?.enabled) {
                lenghtMeasurer.deleteAll();
                lenghtMeasurer.enabled = false;
            }

            if (highlighterState) {
                highlighterState.clear();
                highlighterState.enabled = clipper.enabled;
            }
            clipper.enabled = !clipper.enabled;
        }
    }
    const changeMeasurmentEnabled = () => {
        if (lenghtMeasurer) {
            if (lenghtMeasurer.enabled) {
                lenghtMeasurer.deleteAll();
            }
            else if (clipper?.enabled) {
                clipper.deleteAll();
                clipper.enabled = false;
            }

            if (highlighterState) {
                highlighterState.clear();
                highlighterState.enabled = lenghtMeasurer.enabled;
            }
            lenghtMeasurer.enabled = !lenghtMeasurer.enabled;
        }
    }
    const handleResize = React.useCallback(() => {
        worldState?.renderer?.resize(new THREE.Vector2(getViewerWidth(), getViewerHeight()));
        (worldState?.camera as OBC.SimpleCamera)?.updateAspect();

        (worldState?.camera as OBC.SimpleCamera)?.update(0);
    }, [showGrid, worldState]);
    React.useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);
    React.useEffect(() => {
        handleResize();
    }, [handleResize]);




    const viewerDoubleClick = () => {
        if (clipper?.enabled) {
            clipper.create(worldState!);
        }
        else if (lenghtMeasurer?.enabled) {
            lenghtMeasurer.create(worldState!);
        }
    }
    // const getViewerHeight = () => {
    //     if (props.embeded)
    //         return '180px';
    //     else return showGrid ? (window.innerHeight - 456) + 'px' : (window.innerHeight - 80) + 'px';
    // };
    const getViewerHeight = () => {
        if (props.embeded)
            return 300;
        else if (props.modelData)
            return showGrid ? window.innerHeight - 440 : window.innerHeight - 80;
        else return showGrid ? window.innerHeight - 456 : window.innerHeight - 80;
    }
    const getViewerWidth = () => {
        if (props.embeded)
            return props.containerWidth ?? 500;
        else return window.innerWidth;
    };
    const circularButtonStyle: SxProps<Theme> = {
        borderRadius: '50%',
        minWidth: '56px',
        width: '56px',
        height: '56px',
        padding: 0
    };
    const circularButtonStyleSmall: SxProps<Theme> = {
        borderRadius: '50%',
        minWidth: '40px',
        width: '40px',
        height: '40px',
        padding: 0
    };

    return (
        <Box height={fullHeight}>

            <Backdrop open={loading}>
                <CircularProgress />
            </Backdrop>

            <Box display='flex' flexDirection='column' >
                <Box style={{ height: getViewerHeight(), width: getViewerWidth() }} onDoubleClick={viewerDoubleClick} id='container'>
                </Box>
                {props.embeded !== true && <Stack sx={{ height: 'calc(100vh - 48px)', position: 'absolute', left: 0 }} direction={'column'} spacing={2} p={2}>

                    {!props.modelData && <Uploader
                        small={showGrid}
                        uploadStarted={() => setLoading(true)}
                        ifcUploaded={(uri, uploadUriForFrags, dbModelId) => IfcUploaded(uri, uploadUriForFrags, dbModelId, componentsState, worldState, authorizedApi, setLoading, modelIds.length)} />}

                    <Tooltip title='Řezy'>
                        <Button color='secondary' sx={showGrid ? circularButtonStyleSmall : circularButtonStyle} variant='contained' onClick={changeClipperEnabled}><WaterfallChart fontSize={showGrid ? 'small' : 'medium'} /></Button>
                    </Tooltip>
                    <Tooltip title='resetovat vrtsty'>
                        <Button color='secondary' variant='contained' sx={showGrid ? circularButtonStyleSmall : circularButtonStyle} onClick={() => ResetPostProcessing(componentsState!, highlighterState!, setResetHideIsolate)}><Refresh fontSize={showGrid ? 'small' : 'medium'} /></Button>
                    </Tooltip>
                    <Tooltip title='Tabulka vlastností'>
                        <Button color='secondary' sx={showGrid ? circularButtonStyleSmall : circularButtonStyle} variant='contained' onClick={() => setShowGrid(!showGrid)}><TableChart fontSize={showGrid ? 'small' : 'medium'} /></Button>
                    </Tooltip>
                    <Tooltip title='Měření'>
                        <Button color='secondary' sx={showGrid ? circularButtonStyleSmall : circularButtonStyle} variant='contained' onClick={changeMeasurmentEnabled}><SquareFoot fontSize={showGrid ? 'small' : 'medium'} /></Button>
                    </Tooltip>
                    <Tooltip title='Strom modelu'>
                        <Button color='secondary' sx={showGrid ? circularButtonStyleSmall : circularButtonStyle} variant='contained' onClick={() => { setShowTree(!showTree) }}><AccountTree fontSize={showGrid ? 'small' : 'medium'} /></Button>
                    </Tooltip>
                    {!props.modelData && <Tooltip title='Screenshot'>
                        <Button color='secondary' sx={showGrid ? circularButtonStyleSmall : circularButtonStyle} variant='contained' onClick={() => {

                            // Save the current background color

                            worldState?.renderer?.three.setClearColor('#FFFFFF');

                            // Render the scene again with the white background
                            worldState?.renderer?.three.render(worldState?.scene.three, worldState?.camera.three);

                            const base64 = worldState?.renderer?.three.domElement.toDataURL();
                            const base64ToBlob = (base64: string): Blob => {
                                const parts = base64.split(';base64,');
                                const contentType = parts[0].split(':')[1];
                                const raw = window.atob(parts[1]);
                                const rawLength = raw.length;
                                const uInt8Array = new Uint8Array(rawLength);

                                for (let i = 0; i < rawLength; ++i) {
                                    uInt8Array[i] = raw.charCodeAt(i);
                                }

                                return new Blob([uInt8Array], { type: contentType });
                            };
                            const blobToFile = (blob: Blob, fileName: string): File => {
                                return new File([blob], fileName, { type: blob.type });
                            };
                            if (base64) {
                                projectApi.authorizedApi?.uploadProjectImage({ data: base64ToBlob(base64), fileName: 'screenshot.png' } as FileParameter, Number(params.id!));

                            }


                        }}><Camera fontSize={showGrid ? 'small' : 'medium'} /></Button>
                    </Tooltip>}


                </Stack>}
                {modelIds.length > 0 && showTree &&
                    <DragableWindow
                        minWidth={400}
                        height={500}
                        onCloseClicked={() => { setShowTree(false) }}
                        headerIcon={<AccountTree />}
                        title='Strom modelu'>
                        <ModelTree
                            authorized={!props.modelData}
                            resetElementsHideIsolate={resetHideIsolate}
                            onIsolate={(elements) => Isolate(elements, componentsState!, modelIds)}
                            onSelect={(elements) => Select(elements, componentsState!, highlighterState!, modelIds)}
                            onHide={(elements) => Hide(elements, componentsState!, modelIds)}
                            modelIds={modelIds} /></DragableWindow>}
                {!props.embeded && <div id="cube-scene" className='cube-scene'></div>}
                {showGrid && <Box >
                    <PropertiesDataGrid
                        authorized={!props.modelData}
                        onHide={(elements) => Hide(elements, componentsState!, modelIds)}
                        onIsolate={(elements) => Isolate(elements, componentsState!, modelIds)}
                        onSelected={(elements) => Select(elements, componentsState!, highlighterState!, modelIds)}
                    />
                </Box>}
            </Box>
        </Box >
    );
}
